import { StaticBackground } from '@/features/styles/components/Background/StaticBackground';
import { useMetaThemeColor } from '@/hooks/useMetaThemeColor';
import { usePageTitle } from '@/hooks/usePageTitle';
import { Button, Center, Flex, Image, Text } from '@/ui';
import magnifyingGlass from './magnifyingGlass.png';

export const NotFound = () => {
  usePageTitle('Page not found');
  useMetaThemeColor('#E9DFFF');

  return (
    <Center flex="1" sx={{ '--experience-page-background': '#E9DFFF' }}>
      <StaticBackground />

      <Flex align="center" flexDir="column" gap="4">
        <Image maxW="70px" src={magnifyingGlass} />

        <Text
          fontSize={{ base: 'xl', md: '3xl' }}
          fontWeight="bold"
          lineHeight="1.2"
          maxW="500px"
          px="10"
          sx={{ textWrap: 'balance' }}
          textAlign="center"
        >
          The page you&apos;re looking for couldn&apos;t be found
        </Text>

        <Button as="a" href="/">
          go to agendahero.com
        </Button>
      </Flex>
    </Center>
  );
};
